import { Action } from 'redux'

export const CHANGE_LANG = '[core] Change Language'
export const SET_LANG_KEYS = '[core] Set Lang Keys'
export const LANG_CHANGED = '[core] Language Changed'

export class SetLangKeysAction implements Action {
  readonly type = SET_LANG_KEYS
  constructor(public payload: string) {}
}

export class ChangeLangAction implements Action {
  readonly type = CHANGE_LANG
  constructor(public payload: string) {}
}

export class LangChangedAction implements Action {
  readonly type = LANG_CHANGED
  constructor(public payload: string) {}
}

type I18nActions = ChangeLangAction | LangChangedAction

export default I18nActions



// WEBPACK FOOTER //
// ./src/app/core/store/i18n.actions.ts